import useCopyLink from '@anm/components/CopyLink/hooks';
import { ChangeEvent, FC, useState } from 'react';
import Input from '../Input';
import { Wrapper, Subtitle, ShowButton, CopyButton, InputWrapper } from './styles';

type CmpProps = {
  disabled: boolean;
  onChange: (v: string) => void;
  value?: string;
};

const InputPassword: FC<CmpProps> = ({ value: initialValue, disabled, onChange }) => {
  const [value, setValue] = useState(initialValue);
  const [isHidden, setHidden] = useState(true);
  const [isError, setIsError] = useState(false);

  const handleInputBlur = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value) {
      setIsError(false);
      onChange(value);
    } else {
      setIsError(true);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value);

  const { handleClick, copyLinkButtonText } = useCopyLink({ link: value || '', buttonText: 'Copy password' });

  return (
    <Wrapper {...{ disabled }}>
      <Subtitle>Password</Subtitle>
      <InputWrapper>
        <Input
          variant="password"
          type={isHidden ? 'password' : 'text'}
          value={value}
          hasError={isError}
          autoFocus
          disabled={disabled}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
        />
        <ShowButton onClick={() => setHidden(v => !v)}>{isHidden ? 'Show' : 'Hide'}</ShowButton>
      </InputWrapper>
      <CopyButton onClick={handleClick}>{copyLinkButtonText}</CopyButton>
    </Wrapper>
  );
};

export default InputPassword;
